import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface RoleGuardProps {
  userRoles?: string[];
  allowedRoles: string[];
}

const RoleGuard: React.FC<RoleGuardProps> = ({
  userRoles = [],
  allowedRoles,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const hasAccess = userRoles.some((role) => allowedRoles.includes(role));

    if (!hasAccess) {
      navigate(`${process.env.PUBLIC_URL}/unauthorized`);
    }
  }, [userRoles, allowedRoles, navigate]);

  return null;
};

export default RoleGuard;
